
import React, {FC} from 'react';

import {Close} from './Close';
import {Content} from './Content';
import {Header} from './Header';
import {useState} from './reducer';
import {Start} from './Start';

import * as styles from './styles.module.scss';

export const VoiceAgent: FC = () => {
	const {state, ...handlers} = useState();
	return (
		<div className={styles.wrapper}>
			<Header open={state.open}>
				{state.open ? (
					<Close onClick={handlers.toggleOpen} />
				) : (
					<Start onClick={handlers.toggleOpen} />
				)}
			</Header>
			{state.open && (
				<Content
					state={state}
					handlers={handlers}
				/>
			)}
		</div>
	);
};
